export const DEFAULT_H3_CONFIG = Object.freeze({
  enabled: true,
  status: 'active',
  resolution: 8,
  fallbackToLatLon: true,
  autoRetry: true,
  lastUpdated: null,
});

export const isH3CellId = (value) => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return trimmed.length >= 6 && /^[0-9a-fA-F]+$/.test(trimmed);
};

export const normalizeH3Bucket = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

export const resolveSpatialBucket = (record = {}, fallbackLabel = 'Unknown', config = DEFAULT_H3_CONFIG) => {
  const candidateValues = [
    record.pickup_h3,
    record.dropoff_h3,
    record.h3,
    record.hexagon_id,
    record.h3_index,
    record.pickup_hex,
    record.dropoff_hex,
    record.origin_h3,
    record.destination_h3,
  ];

  const h3Candidate = candidateValues.find((value) => isH3CellId(value));

  if (config.enabled && h3Candidate) {
    return {
      bucket: normalizeH3Bucket(h3Candidate),
      source: 'h3',
    };
  }

  const fallback = normalizeH3Bucket(typeof fallbackLabel === 'string' ? fallbackLabel : '');

  return {
    bucket: fallback || 'Unknown',
    source: config.enabled ? 'fallback' : 'latlon',
  };
};

export const getH3StatusLabel = (config = DEFAULT_H3_CONFIG) => {
  if (!config.enabled) return 'H3 disabled';
  if (config.status === 'degraded') return 'H3 degraded';
  return 'H3 active';
};
